// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"173":"39a9d688","453":"544f742a","963":"12c53362"}[chunkId] + ".chunk.js";
};